/*
 * @Author: louzhedong
 * @Date: 2020-07-02 14:02:01
 * @LastEditors: louzhedong
 * @LastEditTime: 2020-09-04 17:26:46
 * @Description:
 */
/*
 * @Author: Michael
 * @Date: 2018-09-18 09:24:34
 * @Last Modified by: wufan
 * @Last Modified time: 2020-06-23 19:34:17
 */

import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosPromise } from 'axios';
import Vue from 'vue';
import Store from '@/store';
import CONFIG from '@/common/config';
import { ResponseText } from '@/common/constants';
import { AxiosPromiseError } from '@/common/interface';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';

interface FetchInterface {
  fetch(method: string, url: string, data: any, host: string, showLoading: boolean): Promise<any>;
}

class Fetch implements FetchInterface {
  [key: string]: any;
  private timeout: number;
  constructor() {
    this.timeout = 30000;
  }

  public postFetch(method: string, url: string, data: any, host: string, showLoading: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      let SERVER: string = CONFIG.localServer;
      if (process.env.NODE_ENV === 'production') {
        SERVER = (CONFIG.server as any)[process.env.VUE_APP_DEPLOY_ENV as string];
      }

      const v = getUrlParam('v') || getUrlParam('vn');
      const token = getUrlParam('token') || '';
      const uid = getUrlParam('uid');
      const aid = getUrlParam('aid');
      const p = getUrlParam('p') || 'h5';
      const instance: AxiosInstance = axios.create({
        timeout: this.timeout,
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'xmToken': token,
          'bizAccountId': aid
        }
      });
      if (host) {
        SERVER = host;
        url += `?p=${p}&v=${v}&userType=B&token=${token}&uid=${uid}&aid=${aid}`;
      }

      instance.interceptors.request.use(
        (config: AxiosRequestConfig): AxiosRequestConfig => {
          return config;
        },
        (error: Error): Promise<any> => {
          return Promise.reject(error);
        }
      );
      const IgnoreCode = ['GAIN_NOT_IN_TIME', 'BARGAIN_HELP_ALREADY', 'ACTIVITY_OVERDUE', 'ACTIVITY_NUMBER_FULL', 'OVER_STANDARD'];
      instance.interceptors.response.use(
        (response: AxiosResponse): AxiosResponse | AxiosPromise => {
          const { code, message, success, resultMsg } = response.data;
          if (!success) {
            if (IgnoreCode.indexOf(code) === -1) Vue.$toast.error(message || resultMsg);
            return Promise.reject(response.data);
          }
          return response;
        },
        (error: AxiosPromiseError): AxiosPromise => {
          const responseMap = {
            400: ResponseText.PARAM_ERROR,
            404: ResponseText.NOT_FOUND,
            500: ResponseText.ERROR
          };
          return Promise.reject(error.response.data.message);
        }
      );

      let config: any;
      const { urlUid } = Store.state;
      if (urlUid) {
        data.parentUid = urlUid;
      }
      if (method === 'GET') {
        config = Object.assign({ params: data, url: SERVER + url, method });
      } else {
        config = Object.assign({ data, url: SERVER + url, method });
      }
      // if (showLoading) {
      //   Vue.$loading.show('正在加载…');
      // }
      instance(config)
        .then((res: AxiosResponse): void => {
          if (showLoading) {
            Vue.$loading.hide();
          }
          resolve(res.data);
        })
        .catch((error: Error) => {
          if (showLoading) {
            Vue.$loading.hide();
          }
          reject(error);
        });
    });
  }
  public fetch(method: string, url: string, data: any, host: string, showLoading: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      let SERVER: string = CONFIG.localServer;
      if (process.env.NODE_ENV === 'production') {
        SERVER = (CONFIG.server as any)[process.env.VUE_APP_DEPLOY_ENV as string];
      }
      if (host) {
        SERVER = host;
      }

      const instance: AxiosInstance = axios.create({
        timeout: this.timeout,
        responseType: 'json',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      if (method != 'GET') {
        instance.defaults.transformRequest = [
          (queryParam): string => {
            let ret: string = '';
            const queryKeys = Object.keys(queryParam);
            queryKeys.forEach((item: string, index: number): void => {
              if (index < queryKeys.length - 1) {
                ret += `${encodeURIComponent(item)}=${encodeURIComponent(queryParam[item])}&`;
              } else {
                ret += `${encodeURIComponent(item)}=${encodeURIComponent(queryParam[item])}`;
              }
            });
            ret.replace(/&$/, '');
            return ret;
          }
        ];
      }

      instance.interceptors.request.use(
        (config: AxiosRequestConfig): AxiosRequestConfig => {
          return config;
        },
        (error: Error): Promise<any> => {
          return Promise.reject(error);
        }
      );

      const IgnoreCode = [1410, 1403, 1407, 1114, 1519, 1520, 1402, 1516, 1406];
      const checkCode = (resultCode: number): boolean => (IgnoreCode.indexOf(resultCode) >= 0 ? false : true);
      instance.interceptors.response.use(
        (response: AxiosResponse): AxiosResponse | AxiosPromise => {
          if (response.data.resultCode !== 0) {
            if (checkCode(response.data.resultCode)) {
              Vue.$toast.error(response.data.resultMsg);
            }
            return Promise.reject(response.data);
          }
          return response;
        },
        (error: AxiosPromiseError): AxiosPromise => {
          const responseMap = {
            400: ResponseText.PARAM_ERROR,
            404: ResponseText.NOT_FOUND,
            500: ResponseText.ERROR
          };
          Vue.$toast.error((responseMap as any)[error.response.status]);
          return Promise.reject(error.response.data.message);
        }
      );

      let config: any;
      const { urlUid } = Store.state;
      if (urlUid) {
        data.parentUid = urlUid;
      }
      if (method === 'GET') {
        config = Object.assign({ params: data, url: SERVER + url, method });
      } else {
        config = Object.assign({ data, url: SERVER + url, method });
      }
      // if (showLoading) {
      //   Vue.$loading.show('正在加载…');
      // }
      instance(config)
        .then((res: AxiosResponse): void => {
          if (showLoading) {
            Vue.$loading.hide();
          }
          resolve(res.data);
        })
        .catch((error: Error) => {
          if (showLoading) {
            Vue.$loading.hide();
          }
          reject(error);
        });
    });
  }
}

const httpTypeArray: ReadonlyArray<string> = ['post', 'get', 'put'];

httpTypeArray.forEach((item: string): void => {
  Fetch.prototype[item] = function (url: string, data: any): Promise<any> {
    return this.fetch(item.toUpperCase(), `api-s/${url}`, data, false, true);
  };
});

httpTypeArray.forEach((item: string): void => {
  Fetch.prototype[`new${item}`] = function (url: string, data: any): Promise<any> {
    return this.postFetch(item.toUpperCase(), `api-s/${url}`, data, false, true);
  };
});
Fetch.prototype.Sales = function (url: string, data: any): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return this.postFetch('post', `sales/${url}`, data, host, true);
};
Fetch.prototype.Finance = function(url: string, data: any): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return this.postFetch('post', `finance/${url}`, data, host, true);
};
Fetch.prototype.Business = function (url: string, data: any): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return this.postFetch('post', `public/${url}`, data, host, true);
};

Fetch.prototype.parseUrl = function (videoUrl: string): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return new Promise(resolve => {
    this.postFetch('post', `mfs/anon/video/parse`, { videoUrl }, host, true).then((res: any) => {
      resolve(res.result.sdUrl || videoUrl);
    });
  });
};

Fetch.prototype.pureUrl = function (url: string, data: any): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return this.postFetch('post', `${url}`, data, host, true);
};
Fetch.prototype.MFS = function (url: string, data: any): Promise<any> {
  let host: string = CONFIG.localServerB;
  if (process.env.NODE_ENV === 'production') {
    host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
  }
  return this.postFetch('post', `mfs/${url}`, data, host, true);
};

export default new Fetch();
